import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-sticky-note-2-fill",
  "use": "icon-sticky-note-2-fill-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-sticky-note-2-fill\">\n    <g>\n        <path fill=\"none\" d=\"M0 0h24v24H0z\" />\n        <path d=\"M21 16l-5.003 5H3.998A.996.996 0 0 1 3 20.007V3.993C3 3.445 3.445 3 3.993 3h16.014c.548 0 .993.447.993.999V16z\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol